/*
 * LAND · Conversión Kim's Mart (sept 2026)
 * - "Agregar" en tarjetas: 1 toque suma 1 pieza sin abrir el carrito; luego − cantidad +.
 * - Barra fija con piezas, total y, cerca de la meta, avance al envío gratis; "Ver carrito" abre el cajón de Kalles.
 * - Se mantiene al día cuando Kalles (página de producto, cajón) u otra pestaña cambian el carrito.
 * Configuración en window.LAND_CONV (snippets/land-cart-bar.liquid).
 *
 * Los toques se juntan como "piezas de más o de menos" y se mandan relativos a lo que tiene el
 * carrito en ese momento (sumar con add.js; quitar leyendo el carrito recién), así una pestaña
 * vieja o un producto repartido en dos renglones nunca bajan la cantidad por error.
 */
(function () {
  'use strict';

  var CFG = window.LAND_CONV || {};
  if (CFG.__init) return;
  CFG.__init = true;

  var root = String(CFG.root || '/').replace(/\/?$/, '/');
  var nativeFetch = window.fetch.bind(window);
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var MUTATION_URL = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var GENERIC_ERROR = 'No se pudo actualizar el carrito. Intenta otra vez.';

  // qty/lines: lo que dice el carrito; delta: toques aún sin mandar; sent: lo que va en camino;
  // base: la cantidad de la que partió lo que va en camino.
  // Los cambios salen en fila, uno a la vez, para que las respuestas lleguen en orden.
  var state = { cart: null, qty: {}, lines: {}, delta: {}, sent: {}, base: {}, timers: {}, queue: [], running: false, seq: 0 };
  var bar, barFill, barCount, barTotal, barMsg, barCta, toastEl, toastTimer, syncTimer, notifyTimer;
  var selfNotify = false;

  /* ---------- dinero ---------- */
  function withDelimiters(cents, precision, thousands, decimal) {
    var parts = (cents / 100).toFixed(precision).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return whole + (parts[1] ? decimal + parts[1] : '');
  }
  function money(cents) {
    var fmt = CFG.moneyFormat || '${{amount}}';
    cents = Number(cents) || 0;
    var key = (fmt.match(/\{\{\s*(\w+)\s*\}\}/) || [0, 'amount'])[1];
    var value;
    if (key === 'amount_no_decimals') value = withDelimiters(cents, 0, ',', '.');
    else if (key === 'amount_with_comma_separator') value = withDelimiters(cents, 2, '.', ',');
    else if (key === 'amount_no_decimals_with_comma_separator') value = withDelimiters(cents, 0, '.', ',');
    else value = withDelimiters(cents, cents % 100 === 0 ? 0 : 2, ',', '.');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value).replace(/<[^>]*>/g, '');
  }

  /* ---------- red ---------- */
  // Se usa window.fetch al momento (no una copia vieja) para que el aviso de "agregado al carrito"
  // de Shopify (píxeles de Meta y Google) vea también lo que se agrega desde las tarjetas.
  function request(path, init) {
    init = init || {};
    init.landOwn = true;
    init.credentials = 'same-origin';
    init.headers = init.headers || {};
    init.headers.Accept = 'application/json';
    return window.fetch(root + path, init).then(function (r) {
      return r.text().then(function (text) {
        var json = null;
        try { json = text ? JSON.parse(text) : {}; } catch (e) {}
        if (!r.ok || !json || json.status) {
          var message = json && (json.description || json.message);
          // Solo los avisos de Shopify en español (422: existencias); nunca texto técnico
          var error = new Error(r.status === 422 && typeof message === 'string' && message ? message : GENERIC_ERROR);
          error.status = r.status;
          throw error;
        }
        return json;
      });
    });
  }
  function readCart() {
    return request('cart.js');
  }
  function post(path, body) {
    return request(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    });
  }
  function busy() {
    if (state.running || state.queue.length) return true;
    for (var id in state.delta) if (state.delta[id]) return true;
    return false;
  }
  function sync() {
    // Con cambios propios en camino, se lee después para no pintar un carrito a medias
    if (busy()) { scheduleSync(); return Promise.resolve(state.cart); }
    var seq = state.seq;
    return readCart().then(function (cart) {
      // Si mientras se leía salió un cambio nuestro, esta lectura ya es vieja: se vuelve a leer
      if (seq !== state.seq || busy()) { scheduleSync(); return state.cart; }
      applyCart(cart);
      // Si otra app cambió el carrito y el contador de Kalles quedó viejo, que se actualice
      var counter = document.querySelector('[data-cart-count]');
      if (cart && counter && String(cart.item_count) !== counter.textContent.trim()) notifyTheme();
      return cart;
    }).catch(function () {});
  }
  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, 250);
  }

  /* ---------- estado ---------- */
  function applyCart(cart) {
    if (!cart || !cart.items) return cart;
    state.cart = cart;
    state.qty = {};
    state.lines = {};
    cart.items.forEach(function (item) {
      var id = String(item.variant_id);
      state.qty[id] = (state.qty[id] || 0) + item.quantity;
      (state.lines[id] = state.lines[id] || []).push({ key: item.key, quantity: item.quantity });
    });
    renderAll();
    return cart;
  }
  function currentQty(id) {
    var base = state.base[id] != null ? state.base[id] : (state.qty[id] || 0);
    return Math.max(0, base + (state.sent[id] || 0) + (state.delta[id] || 0));
  }

  /* ---------- pintar ---------- */
  function renderCard(el) {
    var id = el.getAttribute('data-variant-id');
    var add = el.querySelector('[data-land-qa-add]');
    var stepper = el.querySelector('[data-land-qa-stepper]');
    var qtyEl = el.querySelector('[data-land-qa-qty]');
    var plus = el.querySelector('[data-land-qa-plus]');
    if (!add || !stepper) return;
    var q = currentQty(id);
    var max = parseInt(el.getAttribute('data-max'), 10);
    var active = document.activeElement;
    var hadFocus = !!active && active !== document.body && el.contains(active);
    // Solo se escribe lo que cambia: escribir igual dispara al observador y se vuelve un ciclo
    if (add.hidden !== q > 0) add.hidden = q > 0;
    if (stepper.hidden !== !(q > 0)) stepper.hidden = !(q > 0);
    if (q > 0 && qtyEl && qtyEl.textContent !== String(q)) qtyEl.textContent = q;
    // Sin 'disabled' para que el toque de más muestre el aviso de existencias
    if (plus) plus.classList.toggle('is-max', !isNaN(max) && q >= max);
    el.classList.toggle('is-in-cart', q > 0);
    // Si el botón con foco se escondió, el foco pasa al que lo reemplaza (teclado y lectores de pantalla)
    if (hadFocus && active.closest('[hidden]')) {
      var next = q > 0 ? plus : add;
      if (next) try { next.focus({ preventScroll: true }); } catch (e) { next.focus(); }
    }
  }
  function renderCards(scope) {
    (scope || document).querySelectorAll('[data-land-qa]').forEach(renderCard);
  }
  function setBarVisible(visible) {
    bar.classList.toggle('is-visible', visible);
    bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    bar.inert = !visible;
    if (barCta) barCta.tabIndex = visible ? 0 : -1;
    document.documentElement.classList.toggle('land-bar-on', visible);
  }
  function renderBar() {
    if (!bar || !state.cart) return;
    var count = state.cart.item_count || 0;
    if (count <= 0) {
      setBarVisible(false);
      return;
    }
    var total = state.cart.total_price || 0;
    var threshold = Number(CFG.threshold) || 0;
    barCount.textContent = count + (count === 1 ? ' pieza' : ' piezas');
    barTotal.textContent = money(total);
    if (threshold > 0) {
      var left = threshold - total;
      // Lejos de la meta no se repite «Te faltan…» en cada página: solo desde CFG.nudgeFrom
      var near = left <= 0 || total >= (Number(CFG.nudgeFrom) || 0);
      barFill.style.width = Math.max(4, Math.min(100, Math.round(total * 100 / threshold))) + '%';
      barMsg.textContent = !near ? '' : left > 0 ? 'Te faltan ' + money(left) + ' para envío gratis' : '¡Ya tienes envío gratis!';
      bar.classList.toggle('is-far', !near);
      bar.classList.toggle('is-done', left <= 0);
    } else {
      barMsg.textContent = '';
    }
    setBarVisible(true);
  }
  function renderAll() {
    renderCards();
    renderBar();
  }
  function bump() {
    if (!bar || reduceMotion) return;
    bar.classList.remove('is-bump');
    void bar.offsetWidth;
    bar.classList.add('is-bump');
  }
  function toast(message) {
    if (!toastEl || !message) return;
    toastEl.textContent = message;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3200);
  }

  /* ---------- avisar a Kalles (contador del encabezado y cajón) ---------- */
  function notifyTheme() {
    selfNotify = true;
    try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
    selfNotify = false;
  }
  // Un solo aviso cuando terminan los toques: Kalles no ordena sus respuestas y una vieja
  // podía llegar al final y dejar el contador atrasado
  function notifyThemeSoon() {
    clearTimeout(notifyTimer);
    notifyTimer = setTimeout(function () {
      if (busy()) notifyThemeSoon();
      else notifyTheme();
    }, 300);
  }
  function drawerIsOpen() {
    var drawer = document.getElementById('t4s-mini_cart');
    return !!drawer && (drawer.getAttribute('aria-hidden') === 'false' || drawer.classList.contains('is--opend') || drawer.classList.contains('is-open'));
  }
  function openCart() {
    try { document.dispatchEvent(new CustomEvent('cart:refresh:opend', { bubbles: true })); } catch (e) {}
    setTimeout(function () {
      if (!drawerIsOpen()) window.location.href = CFG.cartUrl || '/cart';
    }, 1600);
  }

  /* ---------- cambiar cantidades (con espera corta para juntar toques) ---------- */
  function setQty(id, target, el) {
    var max = el ? parseInt(el.getAttribute('data-max'), 10) : NaN;
    if (!isNaN(max) && target > max) {
      target = Math.max(0, max);
      toast(max > 0 ? 'Solo hay ' + max + ' disponibles' : 'Ya no hay existencias');
    }
    if (target < 0) target = 0;
    state.delta[id] = (state.delta[id] || 0) + (target - currentQty(id));
    document.querySelectorAll('[data-land-qa][data-variant-id="' + id + '"]').forEach(renderCard);
    clearTimeout(state.timers[id]);
    state.timers[id] = setTimeout(function () { commit(id); }, 350);
  }
  // Sumar: add.js suma a lo que ya hay en el carrito, venga de donde venga
  function addUnits(id, units) {
    return post('cart/add.js', { items: [{ id: Number(id), quantity: units }] }).then(readCart);
  }
  // Quitar: se lee el carrito en ese momento y se descuenta renglón por renglón
  function removeUnits(id, units) {
    return readCart().then(function (cart) {
      var lines = [];
      cart.items.forEach(function (item) {
        if (String(item.variant_id) === id) lines.push({ key: item.key, quantity: item.quantity });
      });
      var left = units;
      var chain = Promise.resolve(cart);
      lines.forEach(function (line) {
        chain = chain.then(function (current) {
          if (left <= 0) return current;
          var take = Math.min(left, line.quantity);
          left -= take;
          return post('cart/change.js', { id: line.key, quantity: line.quantity - take });
        });
      });
      return chain;
    });
  }
  function commit(id) {
    if (state.running) {
      if (state.queue.indexOf(id) < 0) state.queue.push(id);
      return;
    }
    var units = state.delta[id] || 0;
    delete state.delta[id];
    if (!units) {
      renderAll();
      commitNext();
      return;
    }
    state.running = true;
    state.seq++;
    state.base[id] = state.qty[id] || 0;
    state.sent[id] = units;
    (units > 0 ? addUnits(id, units) : removeUnits(id, -units)).then(function (cart) {
      delete state.sent[id];
      delete state.base[id];
      applyCart(cart);
      if (units > 0) bump();
    }).catch(function (error) {
      delete state.sent[id];
      delete state.base[id];
      // 422 = existencias: Shopify agrega lo que se puede y explica en español cuántas quedaron
      toast(error && error.message ? error.message : GENERIC_ERROR);
      renderAll();
      scheduleSync();
    }).then(function () {
      state.running = false;
      if (state.delta[id] && state.queue.indexOf(id) < 0) state.queue.push(id);
      commitNext();
      notifyThemeSoon();
    });
  }
  function commitNext() {
    while (state.queue.length && !state.running) {
      var id = state.queue.shift();
      if (state.delta[id]) commit(id);
    }
  }

  /* ---------- clics ---------- */
  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target.closest('[data-land-qa-add],[data-land-qa-plus],[data-land-qa-minus],[data-land-bar-open]') : null;
    if (!target) return;
    event.preventDefault();
    event.stopPropagation();
    if (target.hasAttribute('data-land-bar-open')) {
      openCart();
      return;
    }
    var el = target.closest('[data-land-qa]');
    if (!el) return;
    var id = el.getAttribute('data-variant-id');
    var step = parseInt(el.getAttribute('data-step'), 10) || 1;
    var min = parseInt(el.getAttribute('data-min'), 10) || 1;
    var q = currentQty(id);
    if (target.hasAttribute('data-land-qa-add')) setQty(id, Math.max(min, q + step), el);
    else if (target.hasAttribute('data-land-qa-plus')) setQty(id, q + step, el);
    else setQty(id, q - step < min ? 0 : q - step, el);
  }, true);

  /* ---------- enterarse de cambios hechos por Kalles, otras apps u otra pestaña ---------- */
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var promise = nativeFetch(input, init);
    if (MUTATION_URL.test(url) && !(init && init.landOwn)) promise.then(scheduleSync, scheduleSync);
    return promise;
  };
  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__landUrl = url;
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (MUTATION_URL.test(String(this.__landUrl || ''))) this.addEventListener('loadend', scheduleSync);
    return xhrSend.apply(this, arguments);
  };
  document.addEventListener('cart:refresh', function () { if (!selfNotify) scheduleSync(); });
  window.addEventListener('pageshow', function (event) { if (event.persisted) sync(); });
  // Al volver a la pestaña el carrito pudo cambiar en otra
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') scheduleSync(); });
  window.addEventListener('focus', scheduleSync);

  /* ---------- acomodos de pantalla ---------- */
  // Alto de la barra inferior de Kalles (Tienda · Favoritos · Carrito · Buscar) para no taparla
  function measureToolbar() {
    var height = 0;
    var section = document.querySelector('.t4s-toolbar-mobile');
    if (section) {
      var candidates = [section].concat(Array.prototype.slice.call(section.querySelectorAll('div')));
      for (var i = 0; i < candidates.length; i++) {
        var cs = window.getComputedStyle(candidates[i]);
        if (cs.position === 'fixed' && cs.display !== 'none' && cs.visibility !== 'hidden' && candidates[i].offsetHeight > 0) {
          height = candidates[i].getBoundingClientRect().height;
          break;
        }
      }
    }
    document.documentElement.style.setProperty('--land-toolbar-h', Math.round(height) + 'px');
  }
  function moveSidebarButton() {
    var button = document.querySelector('.t4s-btn-sidebar');
    var toolbar = document.querySelector('.t4s-collection-header, .t4s-toolbart, .t4s-toolbar-wrapper');
    if (!button || !toolbar || toolbar.contains(button)) return;
    button.classList.add('land-btn-sidebar');
    toolbar.insertBefore(button, toolbar.firstChild);
  }
  // Reseñas de Judge.me: la etiqueta de compra verificada sale en inglés en el carrusel
  function localizeReviews() {
    document.querySelectorAll('.jdgm-reviewer-verified-text').forEach(function (el) {
      if (el.textContent.trim() === 'Verified') el.textContent = 'Verificado';
    });
  }
  function isOwnUi(node) {
    var el = node && node.nodeType === 1 ? node : node && node.parentElement;
    return !!(el && el.closest && el.closest('[data-land-qa],[data-land-bar],[data-land-toast]'));
  }

  function init() {
    bar = document.querySelector('[data-land-bar]');
    if (bar) {
      barFill = bar.querySelector('[data-land-bar-fill]');
      barCount = bar.querySelector('[data-land-bar-count]');
      barTotal = bar.querySelector('[data-land-bar-total]');
      barMsg = bar.querySelector('[data-land-bar-msg]');
      barCta = bar.querySelector('[data-land-bar-open]');
      bar.inert = true;
      if (barCta) barCta.tabIndex = -1;
    }
    toastEl = document.querySelector('[data-land-toast]');
    measureToolbar();
    moveSidebarButton();
    localizeReviews();
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(measureToolbar, 200);
    });
    sync();

    // Tarjetas que llegan después (scroll infinito, pestañas, recomendados) y reseñas que pinta Judge.me.
    // Se ignoran los cambios dentro de nuestros propios botones, barra y aviso.
    if ('MutationObserver' in window) {
      var queued = false;
      new MutationObserver(function (mutations) {
        if (queued) return;
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          if (!added.length || isOwnUi(mutations[i].target)) continue;
          for (var j = 0; j < added.length; j++) {
            if (added[j].nodeType !== 1) continue;
            queued = true;
            window.requestAnimationFrame(function () {
              queued = false;
              if (state.cart) renderCards();
              moveSidebarButton();
              localizeReviews();
            });
            return;
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
